import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Hero from "../components/Hero";
import WhyChoose from "../components/WhyChoose";
import LifeAtSchool from "../components/LifeAtSchool";
import News from "../components/News";
import Footer from "../components/Footer";
import HomeAbout from "../components/HomeAbout";
import { FaTimes } from "react-icons/fa";
import HomeVirtualTour from "./HomeVirtualTour";

const Home = () => {
  const [open, setOpen] = useState(false);
  const [popup, setPopup] = useState(false);

  const [notices, setNotices] = useState([]);

  useEffect(() => {
    fetch("https://njinternational.ilakshyaerp.in/api/notices")
      .then((res) => res.json())
      .then((data) => setNotices(data));

    const alreadyShown =
      sessionStorage.getItem("homePopupShown");

    if (!alreadyShown) {
      setPopup(true);

      sessionStorage.setItem(
        "homePopupShown",
        "yes"
      );
    }
  }, []);

  return (
    <>
      {/* WELCOME POPUP */}
      {popup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.65)",
            zIndex: 99999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "620px",
              background: "#fff",
              borderRadius: "18px",
              padding: "45px 35px",
              textAlign: "center",
              position: "relative",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
              animation: "fadeIn 0.4s ease",
            }}
          >
            {/* CLOSE ICON */}
            <button
              onClick={() => setPopup(false)}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                border: "none",
                background: "#f2f2f2",
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                cursor: "pointer",
                fontSize: "15px",
                color: "#1f3c6d",
              }}
            >
              <FaTimes />
            </button>

            <h1
              style={{
                color: "#1f3c6d",
                fontSize: "38px",
                marginBottom: "15px",
                fontWeight: "700",
              }}
            >
              Welcome to
            </h1>

            <h2
              style={{
                color: "#e93e28",
                fontSize: "32px",
                marginBottom: "18px",
                fontWeight: "800",
                letterSpacing: "1px",
              }}
            >
              NAV JEEVAN MISSION INTERNATIONAL SCHOOL
            </h2>

            <p
              style={{
                color: "#555",
                fontSize: "17px",
                lineHeight: "1.8",
                marginBottom: "25px",
              }}
            >
              Excellence in Education, Character and Leadership.
              We are delighted to welcome you to our website.
            </p>

            <button
              onClick={() => {
                setPopup(false);
                window.location.href = "/about";
              }}
              style={{
                background: "#1f3c6d",
                color: "#fff",
                border: "none",
                padding: "12px 28px",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: "600",
              }}
            >
              Click Here to know about our School
            </button>
          </div>
        </div>
      )}

      <Header toggleSidebar={() => setOpen(true)} />

      <div className="announcement">
        <div className="announcement-label">
          📢 ANNOUNCEMENT
        </div>

        <div className="announcement-track">
          <div className="announcement-content">
            {notices.map((n) => (
              <span
                key={n.id}
                onClick={() =>
                  (window.location.href = `/notices/${n.id}`)
                }
              >
                {n.title}
              </span>
            ))}
          </div>
        </div>
      </div>

      <Sidebar
        isOpen={open}
        close={() => setOpen(false)}
      />

      <Hero />

      <div className="container">
        <WhyChoose />
        <HomeAbout />
        <LifeAtSchool />
        <HomeVirtualTour />
        <News />
      </div>

      <Footer />
    </>
  );
};

export default Home;